import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconButton as BaseIconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { forwardRef } from "react";
import { ColorsInjector } from "../../../utils";
/**
 * @deprecated Please use IconButton from `/lab`
 */
export const IconButton = forwardRef((props, ref) => {
    const theme = useTheme();
    return (_jsx(ColorsInjector, { props: props, children: ({ variant = "ghost", size = "medium", square, color = "inherit", colorSet = variant === "tonal" ? "container" : "main", invertColors = variant !== "filled" && variant !== "tonal", getColorStyles, ...rootProps }) => {
            const colorStyles = getColorStyles({
                color,
                colorSet,
                invertColors,
            });
            const ghost = {
                backgroundColor: "transparent",
            };
            const outlined = {
                border: 1,
                borderColor: theme.palette.stroke[100],
                backgroundColor: "transparent",
            };
            const minimal = {
                padding: 0,
                backgroundColor: "transparent",
            };
            return (_jsx(BaseIconButton, { "data-component-name": "IconButton", ref: ref, disableRipple: variant === "minimal", ...rootProps, sx: {
                    padding: size === "extra-small" || size === "small"
                        ? 0.25
                        : size === "large"
                            ? 0.75
                            : 1,
                    borderRadius: square ? 0.5 : 12,
                    fontSize: size === "extra-small"
                        ? "1.25rem"
                        : size === "small"
                            ? "1.125rem"
                            : size === "medium"
                                ? "1.5rem"
                                : "1.75rem",
                    ...colorStyles,
                    "&:hover": {
                        ...colorStyles,
                    },
                    ...(variant === "ghost" && ghost),
                    ...(variant === "outlined" && outlined),
                    ...(variant === "minimal" && minimal),
                    ...rootProps.sx,
                } }));
        } }));
});
//# sourceMappingURL=IconButton.js.map